export default "__VITE_ASSET__hYjDU6wT__"